// Клиент для `/api/public/drilling_company` — справочник бурильных компаний.
// Используется как ссылочный атрибут в `tool` (для группировки/поиска),
// к правам/владению отношения не имеет.
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/drilling_company.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.

import type { DrillingCompanyDto } from '@webtypes/DrillingCompanyDto'
import type { CreateDrillingCompanyBody } from '@webtypes/CreateDrillingCompanyBody'
import type { UpdateDrillingCompanyBody } from '@webtypes/UpdateDrillingCompanyBody'

export type { DrillingCompanyDto, CreateDrillingCompanyBody, UpdateDrillingCompanyBody }

const BASE = '/api/public/drilling_company'

async function ensureOk(resp: Response): Promise<void> {
  if (!resp.ok) {
    const text = await resp.text().catch(() => '')
    throw new Error(`${resp.status} ${resp.statusText}${text ? ': ' + text : ''}`)
  }
}

export async function listDrillingCompanies(): Promise<DrillingCompanyDto[]> {
  const resp = await fetch(BASE, { credentials: 'same-origin' })
  await ensureOk(resp)
  return resp.json()
}

export async function createDrillingCompany(
  body: CreateDrillingCompanyBody,
): Promise<DrillingCompanyDto> {
  const resp = await fetch(BASE, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  })
  await ensureOk(resp)
  return resp.json()
}

export async function updateDrillingCompany(
  id: string,
  body: UpdateDrillingCompanyBody,
): Promise<DrillingCompanyDto> {
  const resp = await fetch(`${BASE}/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  })
  await ensureOk(resp)
  return resp.json()
}

export async function deleteDrillingCompany(id: string): Promise<void> {
  const resp = await fetch(`${BASE}/${id}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  })
  await ensureOk(resp)
}
